import { css } from 'emotion';

export const alertsGroupClass = css`
  position: fixed;
  top: 20px;
  right: 0;
  z-index: 999999;
  width: 410px;
  box-sizing: border-box;
`;
